import { useMemo } from "react"
import { useGetAmenitiesQuery } from "../../services/bClientApi"
import { AmenityType } from "../../Types/amenityTypes"

export default function useAmenityRefs() {

    const {
        data,
    } = useGetAmenitiesQuery({
        amenitiesQuery: {},
        pagination: {
            page: 1,
            limit: 1000,
        }
    }, {
        refetchOnFocus: false,
        refetchOnMountOrArgChange: 5 * 60
    })

    const amenityRef = useMemo(() => {
        const amenityList = data?.docs || []
        const amenityRefData: { [key: string]: AmenityType } = {}
        if (amenityList) {
            amenityList.forEach((amenity: AmenityType) => {
                if (amenity._id) {
                    amenityRefData[amenity._id] = amenity
                }
            })
        }
        return amenityRefData
    }, [data])

    return amenityRef
}
